
/* ============================== src/components/ListLayoutToggle.jsx ============================== */
// src/components/ListLayoutToggle.jsx
/**
 * Переключатель раскладки списка: «Плитка» или «Полоса».
 *
 * Управляемый - состояние хранит вьюха (TasksView / ProjectsView),
 * компонент только рендерит сегмент-контрол. Единая точка правды
 * о существующих раскладках: набор режимов задан здесь, один на
 * два раздела (задачи и проекты).
 *
 * Использует класс .seg / .seg-btn - тот же сегмент-контрол, что
 * у сортировки обсуждения и у выбора периода в «Загрузке». Не
 * изобретаем новую визуальную деталь для стандартной задачи
 * «выбрать один из двух».
 *
 * Роли radio + aria-checked, а не aria-pressed: клик по кнопке
 * переключает выбор на неё и снимает с другой - это сегментный
 * выбор одного из вариантов, а не независимый тумблер.
 *
 * size='sm' - тот же размер, что у переключателя «Список / Канбан»
 * в ViewModeToggle и у остальных сегмент-контролов в футере
 * раздела. Визуально они в одной строке, разнобой в размерах
 * читался бы как разные по важности группы.
 */
const LAYOUTS = [
  { id: "tiles", label: "Плитка" },
  { id: "rows", label: "Полоса" },
];

export function ListLayoutToggle({ value, onChange }) {
  return (
    <div className="seg sm" role="radiogroup" aria-label="Раскладка списка">
      {LAYOUTS.map(({ id, label }) => (
        <button
          key={id}
          type="button"
          role="radio"
          aria-checked={value === id}
          className={`seg-btn${value === id ? " on" : ""}`}
          onClick={() => onChange(id)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default ListLayoutToggle;
